import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { Box, ProductTile, ProductTileHorizontal, ProductTileImage, StackBlock, TextAlpha, } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { usePriceProps } from '../../../hooks/usePriceProps';
import { getImageUrlForBasketTile } from '../../../util/ImageUtil';
import { getSizeColorLabel } from '../../../util/ProductUtil';
import AsNumeral from '../../../vendors/asNumeral';
export const ProductTileOrderOverview = ({ product }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const { currency, productImageConfig } = useAemConfig();
    const image = getImageUrlForBasketTile(product, productImageConfig, ProductImageSizesPortraitEnum.bundles);
    const priceActual = {
        formattedPrice: AsNumeral.formatAsCurrency(product.totalPrice),
    };
    const pricePrevious = product.productHasDiscount && !!product.totalPreviousPrice
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(product.totalPreviousPrice),
        }
        : undefined;
    const priceReference = product.productHasDiscount && !!product.lowestPrice
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(product.lowestPrice),
        }
        : undefined;
    const priceProps = usePriceProps({
        priceInformation: {
            prices: product.prices,
            hasDiscount: Boolean(product.productHasDiscount),
        },
        fallbackPriceViewModel: {
            priceActual,
            pricePrevious,
            priceReference,
        },
    });
    return (_jsxs(ProductTileHorizontal, { gap: "3", product: Object.assign(Object.assign({ image,
            currency }, priceProps), { title: product.description, brand: product.brand }), testId: "product_tile", children: [_jsx(ProductTile.Cell, { section: "media", children: _jsx(ProductTileImage, { height: 120, width: 80 }) }), _jsx(ProductTile.Cell, { section: "content", children: _jsxs(StackBlock, { gap: "5", children: [_jsx(ProductTile.Title, { brandOnTheSameLine: true, lineClamp: 2 }), _jsxs(TextAlpha, { color: "subtle", children: [product.quantity > 1 && (_jsxs(_Fragment, { children: [t(`${I18N_NAMESPACES.checkout}:checkout.basket.count`, { count: product.quantity }), ", "] })), getSizeColorLabel(product, t)] }), _jsx(Box, { marginInlineStart: "auto", children: _jsx(ProductTile.Price, { align: "end" }) })] }) })] }));
};
